import React from "react"
import { Route, Routes } from "react-router-dom"
import { Login } from "../components/user/Login"
import { Register } from "../components/user/Register"
import { PrivateRoutes } from "./PrivateRoutes"
import { BiRoutes } from "../components/BI/routes/BiRoutes"
import { PublicRoutes } from "./PublicRoutes"
import { UserRoutes } from "../components/user/routes/UserRoutes"
import ErrorBoundary from "../components/ErrorBoundary/ErrorBoundary"
import { PagosRoutes } from "../components/Pagos/routes/PagosRoutes"
import { MarketingRoutes } from "../components/Marketing/routes/MarketingRoutes"
import { CertificacionesRoutes } from '../components/Certificaciones/routes/CertificacionesRoutes';
import { Helpdesk } from "../components/Helpdesk/pages/Helpdesk"

export const AppRoutes = () => {
  
  return (
    <Routes>
      {/* Rutas Publicas */}
      <Route
        path="/"
        element={
          <PublicRoutes>
            <Login />
          </PublicRoutes>
        }
        errorElement={<ErrorBoundary />}
      />
      <Route
        path="/register"
        element={<Register />}
        errorElement={<ErrorBoundary />}
      />
      {/* Rutas Privadas */}
      <Route
        path="/*"
        element={
          <PrivateRoutes>
            <BiRoutes />
            <PagosRoutes />
            <UserRoutes />
            <MarketingRoutes />
            <CertificacionesRoutes />
            <Helpdesk />
          </PrivateRoutes>
        }
        errorElement={<ErrorBoundary />}
      />
    </Routes>
  );
}